import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import Header from './components/Header.tsx';
import SimpleSlider from './components/SimpleSlider.tsx';
import MenuSection from './components/MenuSection.tsx';
import Locations from './components/Locations.tsx';
import Contact from './components/Contact.tsx';
import Footer from './components/Footer.tsx';
import MenuPage from './pages/MenuPage.tsx';
import TableOrderPage from './pages/TableOrderPage.tsx';
import WaiterDashboard from './pages/WaiterDashboard.tsx';
import QRGenerator from './pages/QRGenerator.tsx';
import WhatsAppBot from './components/WhatsAppBot.tsx';
import GlobalStyles from './styles/GlobalStyles.ts';

const AppContainer = styled.div`
  min-height: 100vh;
  overflow-x: hidden;
`;

const MainContent = styled.main`
  position: relative;
`;

const ScrollToState: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname !== '/') return;
    const targetId = (location.state as any)?.scrollTo as string | undefined;
    if (!targetId) return;

    const raf = requestAnimationFrame(() => {
      const el = document.getElementById(targetId);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
      // Limpia el state para que no vuelva a scrollear en renders futuros
      navigate(location.pathname, { replace: true, state: {} });
    });

    return () => cancelAnimationFrame(raf);
  }, [location.pathname, location.state, navigate]);

  return null;
};

function App() {
  return (
    <Router>
      <AppContainer>
        <GlobalStyles />
        <ScrollToState />
        <Header />
        <Routes>
          <Route path="/" element={
            <MainContent>
              <SimpleSlider />
              <MenuSection />
              <Locations />
              <Contact />
            </MainContent>
          } />
          <Route path="/menu/:location" element={<MenuPage />} />
          <Route path="/order/:locationId/table/:tableId" element={<TableOrderPage />} />
          <Route path="/admin/dashboard" element={<WaiterDashboard />} />
          <Route path="/admin/qr/:locationId" element={<QRGenerator />} />
        </Routes>
        <Footer />
        <WhatsAppBot />
      </AppContainer>
    </Router>
  );
}

export default App;